// ABOUTME: Screen 2D Weather Response: the weather carousel is the stack's top cloud; confirm_weather sends the focused weather.
// ABOUTME: The carousel opens on the stored weather, and browsing without confirming counts as unsent.

import { useMemo } from 'react';
import { useCrossingContent } from '../../../hooks/useCrossingContent';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import PickStatus from './carousel/PickStatus';
import { useCarouselIndex } from './carousel/useCarouselIndex';
import { useCarouselKeys } from './carousel/useCarouselKeys';

export default function Screen2D({ crossing }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const weatherPatterns = useMemo(() => Object.values(content?.weatherPatterns ?? {}), [content]);
  const { focused, index, count, prev, next, browsed } = useCarouselIndex(weatherPatterns, crossing.weather);
  useCarouselKeys(prev, next);

  return {
    layer: <PickStatus name={focused?.name} index={index} count={count} />,
    cloudTiers: { weather: { item: focused } },
    headline: 'Use the arrows to see which Weather you experienced first.',
    ...(focused && { picker: { label: focused.name, prevLabel: 'Previous weather', nextLabel: 'Next weather', onPrev: prev, onNext: next } }),
    slots: {
      confirm_weather: { disabled: !focused, values: focused ? { weather: focused.code } : undefined },
    },
    hasUnsentState: browsed && !!focused && focused.code !== crossing.weather,
  };
}
